import { createSelector } from "@reduxjs/toolkit";
import { api } from "../../api/api.js";
import { selectCreditLimitsParams } from "./selectCreditLimitsParams.js";
const selectCreditLimits = createSelector(
  [(state) => state, selectCreditLimitsParams],
  (state, params) => {
    if (!params) {
      return;
    }
    return api.endpoints.getCreditLimits.select(params)(state);
  }
);
export {
  selectCreditLimits
};
